import React from "react";

const PageHero = ({
  label,
  labelClass = "text-orange-400",
  title,
  subtitle,
  image,
  imageAlt = "",
  bgClass = "bg-purple-900",
  glowColor = "#ff6a00",
  titleClass = "text-white",
  fadeColor = "#f9fafb",
}) => (
  <div className={`relative ${bgClass} pt-20 overflow-hidden`}>
    {image && (
      <img
        src={image}
        alt={imageAlt}
        className="absolute inset-0 w-full h-full object-cover opacity-[0.13]"
        loading="eager"
      />
    )}
    <div
      className="absolute inset-0 opacity-[0.05]"
      aria-hidden="true"
      style={{
        backgroundImage:
          "radial-gradient(circle, rgba(255,255,255,0.9) 1px, transparent 1px)",
        backgroundSize: "28px 28px",
      }}
    />
    {/* Right glow accent */}
    <div
      className="absolute -top-16 -right-16 w-72 h-72 rounded-full opacity-20 blur-3xl hidden md:block"
      aria-hidden="true"
      style={{ background: `radial-gradient(circle, ${glowColor} 0%, transparent 70%)` }}
    />
    {/* Bottom fade to page bg */}
    <div
      className="absolute bottom-0 left-0 right-0 h-16"
      aria-hidden="true"
      style={{ background: `linear-gradient(to bottom, transparent, ${fadeColor})` }}
    />
    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-16 text-white">
      {label && (
        <p className={`text-[11px] font-bold uppercase tracking-widest mb-3 ${labelClass}`}>
          {label}
        </p>
      )}
      <h1 className={`text-4xl sm:text-5xl font-extrabold leading-tight mb-3 ${titleClass}`}>{title}</h1>
      {subtitle && (
        <p className="text-base sm:text-lg text-white/60 max-w-3xl leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  </div>
);

export default PageHero;
